export default __webpack_public_path__ + "img/397f790a0a86cb0f4844fa7400ee6f30.svg";